import { NgModule } from '@angular/core';
import { NewDrawerComponent } from '@app/shared/components/new-drawer/drawer/new-drawer.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { CreationDrawerComponent } from '@app/shared/components/new-drawer/creation/creation-drawer/creation-drawer.component';
import { SearchDrawerComponent } from '@app/shared/components/new-drawer/search/search-drawer/search-drawer.component';
import { ReactiveFormsModule } from '@angular/forms';
import { DropdownMenuInputModule } from '@app/shared/ui/components/inputs/dropdown-menu/module/dropdown-menu-input.module';
import { CommonModule } from '@angular/common';
import { DataReportsFormComponent } from '@app/shared/components/new-drawer/creation/components/data-reports/data-reports-form.component';
import { CheckboxModule } from '@app/shared/ui/components/inputs/checkbox/module/checkbox.module';
import { TranslatePipe } from '@ngx-translate/core';
import { RadioGroupModule } from '@app/shared/ui/components/inputs/radio-group/module/radio-group.module';
import { AutocompleteModule } from '@app/shared/ui/components/inputs/autocomplete/module/autocomplete.module';
import { ParameterInputModule } from '@app/shared/ui/components/inputs/paramater-field-row/module/parameter-input.module';
import { CancelButtonComponent } from '@app/shared/ui/components/buttons/cancel-button/cancel-button.component';
import { AddButtonComponent } from '@app/shared/ui/components/buttons/add-button/add-button.component';
import { SubmitButtonModule } from '@app/shared/ui/components/buttons/submit-button/module/submit-button.module';
import { WithdrawalFormComponent } from '@app/shared/components/new-drawer/creation/components/accounting/withdrawl/withdrawal-form.component';
import { FreeTextInputModule } from '@app/shared/ui/components/inputs/free-text/module/free-text-input.module';
import { DatepickerInputModule } from '@app/shared/ui/components/inputs/datepicker/module/datepicker-input.module';
import { FormLayoutModule } from '@app/shared/components/new-drawer/form-layout/module/form-layout.module';
import { UpdateInvoiceBalanceFormComponent } from '@app/shared/components/new-drawer/creation/components/accounting/update-invoice-balance/update-invoice-balance-form.component';
import { NewInvoiceFormComponent } from '@app/shared/components/new-drawer/creation/components/accounting/new-invoice/new-invoice-form.component';
import { AddReportsToInvoiceFormComponent } from '@app/shared/components/new-drawer/creation/components/accounting/add-reports-to-invoice/add-reports-to-invoice-form.component';
import { AccountingExportFormComponent } from '@app/shared/components/new-drawer/creation/components/accounting/accounting-export/accounting-export-form.component';
import { ContactFormComponent } from '@app/shared/components/new-drawer/creation/components/organization/contact/contact-form.component';
import { TextareaInputModule } from '@app/shared/ui/components/inputs/textarea-input/module/textarea-input.module';
import { EmployeeFormComponent } from '@app/shared/components/new-drawer/creation/components/organization/employee/employee-form.component';
import { CompanyFormComponent } from '@app/shared/components/new-drawer/creation/components/organization/company/company-form.component';
import { ConflictCheckFormComponent } from '@app/shared/components/new-drawer/creation/components/crm/conflict-check/conflict-check-form.component';
import { BankAccountFormComponent } from '@app/shared/components/new-drawer/creation/components/new-item/bank-account/bank-account-form.component';
import { ExpenseTypeFormComponent } from '@app/shared/components/new-drawer/creation/components/new-item/expense-type/expense-type-form.component';
import { SupplierFormComponent } from '@app/shared/components/new-drawer/creation/components/new-item/supplier/supplier-form.component';
import { DirectivesModule } from '@ui';
import { InputsModule } from '@app/shared/ui/components/inputs/inputs.module';
import { ContactsSearchFormComponent } from '@app/shared/components/new-drawer/search/components/contacts-search/contacts-search-form.component';
import { EmployeesSearchFormComponent } from '@app/shared/components/new-drawer/search/components/employees-search/employees-search-form.component';
import { RecipientsSearchFormComponent } from '@app/shared/components/new-drawer/search/components/recipients-search/recipients-search-form.component';

@NgModule({
	declarations: [
		NewDrawerComponent,
		CreationDrawerComponent,
		SearchDrawerComponent,
		DataReportsFormComponent,
		WithdrawalFormComponent,
		UpdateInvoiceBalanceFormComponent,
		NewInvoiceFormComponent,
		AddReportsToInvoiceFormComponent,
		AccountingExportFormComponent,
		ContactFormComponent,
		EmployeeFormComponent,
		CompanyFormComponent,
		ConflictCheckFormComponent,
		BankAccountFormComponent,
		ExpenseTypeFormComponent,
		SupplierFormComponent,
		ContactsSearchFormComponent,
		EmployeesSearchFormComponent,
		RecipientsSearchFormComponent
	],
	exports: [NewDrawerComponent],
	imports: [
		CommonModule,
		MatSidenavModule,
		MatIconModule,
		ReactiveFormsModule,
		DropdownMenuInputModule,
		CheckboxModule,
		TranslatePipe,
		RadioGroupModule,
		AutocompleteModule,
		ParameterInputModule,
		CancelButtonComponent,
		AddButtonComponent,
		SubmitButtonModule,
		FreeTextInputModule,
		DatepickerInputModule,
		FormLayoutModule,
		TextareaInputModule,
		DirectivesModule,
		InputsModule
	]
})
export class NewDrawerModule {}
